module.exports = "/assets/data/758c8ea32134bdc0320ab925b80e15c8-IP17.data.json";